export const FIND_USER_BUSNESS = "FIND_USER_BUSNESS";
export const FIND_USER_NETWORK = "FIND_USER_NETWORK";
export const INIT = "INIT";
